module.exports = __webpack_public_path__ + "static/body1-d4fd29251737ac3cb80daceb8f24996d.jpg";